import { render } from "./TrangChuLenhDangThucHien.vue?vue&type=template&id=715ae62c&scoped=true"
import script from "./TrangChuLenhDangThucHien.vue?vue&type=script&lang=js"
export * from "./TrangChuLenhDangThucHien.vue?vue&type=script&lang=js"

import "./TrangChuLenhDangThucHien.vue?vue&type=style&index=0&id=715ae62c&scoped=true&lang=css"
import "./TrangChuLenhDangThucHien.vue?vue&type=style&index=1&id=715ae62c&lang=scss&scoped=true"

import exportComponent from "E:\\SonPhat\\Project\\fe_smartphone-doi-soat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-715ae62c"]])

export default __exports__